import { gql } from "@apollo/client";

const CREATE_PROGRAMME = gql`
  mutation createProgramme($programmeData: ProgrammeInput, $baseUrl: String, $apiKey: String, $heiUuid: String)
    {createProgramme(programmeData: $programmeData, baseUrl: $baseUrl, apiKey: $apiKey, heiUuid: $heiUuid) {
      id
      status
      title
      code
      programme__ects
      programme__eqf_level_provided
      programme__isced_code
      language_of_instruction
      description
      learning_outcomes
      programme__abbreviation
      programme__elm_lo_type
      programme__elm_learning_schedule
      programme__elm_mode_of_learning
      programme__length
      url
      programme__valid_since
      programme__valid_until
    }  
  }`
;

export default CREATE_PROGRAMME;
